import React from 'react';
import cn from 'classnames';
import { IFeatureBase, IFeatureTheme, IModFeature } from 'mod/featureV2/interface';
import { FeaturesRender } from 'mod/featureV2/FeaturesRender';
import { getWrapStyle } from 'mod/featureV2/utils';
import { isDark } from 'base/utils/color';
import { IVariant } from 'base/interfaces/product';
import { ModFeature } from '@pro/feature/ModFeature';

export type IFeaturesProps<T> = {
    features: T[];
    containerTheme?: IFeatureTheme;
    render?: (props: { feature: T }) => React.ReactNode;
    variant?: IVariant;
    id?: string;
    className?: string;
};

export function Features<T extends IFeatureBase = IModFeature>(props: IFeaturesProps<T>): Globals.JSXRenderType {
    const { features, containerTheme, render, variant, id, className } = props;

    return (
        <FeaturesRender<T>
            id={id}
            className={className}
            containerTheme={containerTheme}
            features={features}
            render={({ feature }) => {
                // 上级组件扩写
                const parentRendered = render?.({ feature });
                if (parentRendered) {
                    return parentRendered;
                }

                // @ts-ignore
                return <ModFeature feature={feature} variant={variant}/>
            }}
        />
    )
}
